import { createFileRoute } from "@tanstack/react-router";

import Loyalty from "@/components/Loyalty/Loyalty";

export const Route = createFileRoute("/gym/$venueUuid/loyalty")({
  component: Loyalty,
});
